import React, { Component } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "../../css/customBtnPmry.css";
import "./landingPage.css";

export default class LandingPage extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-margin-top">
          <div className="text-center">
            <h1
              style={{
                fontFamily: "TrajanSansPro",
                color: "white",
              }}
            >
              <br /> Welcome to the
              <br /> Vicus Capital
              <br /> Compliance Portal
            </h1>
          </div>

          <div className="page-margin-top">
            <div className="container">
            <div className="page-margin-top row g-3">
              {this.props.groups.includes("Audit") && (
                <div className="col-lg-6 mx-auto">
                  <div className="card">
                    <h5 className="card-header">Audit File Upload</h5>
                    <div className="card-body">
                      <h5 className="card-title">
                        Upload your files via the upload portal
                      </h5>
                      <p className="card-text">
                        You will only see this card when you are being audited
                      </p>
                      <Link className="btn btn-brand" to="/uploads">
                        Upload
                      </Link>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-lg-6 mx-auto">
                <div className="card">
                  <h5 className="card-header">Client Meeting Attestation</h5>
                  <div className="card-body">
                    <p className="card-title"></p>
                    <p className="card-text">
                      <strong>
                        Annual client meetings are a regulatory requirement. Use
                        this tool to attest that you are meeting with your
                        clients on an annual basis. Please let us know if we
                        need to make any edits to your client list.
                      </strong>
                      <br />
                      <br />
                      Client Meeting Attestations Remaining:{" "}
                      {this.props.gettingClients === true ? (
                        <div
                          class="spinner-border spinner-border-sm"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        this.props.clients.filter((c) =>
                          c["attestation-status"]
                            ? c["attestation-status"] !== "Submitted"
                            : false
                        ).length
                      )}
                    </p>
                    <Link
                      className="btn btn-brand "
                      to="/clients"
                      style={{ width: "10rem" }}
                    >
                      Clients
                    </Link>
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      *Client lists are updated annually
                    </span>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
